
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aboutUs",
      function () {
        return require("private-next-pages/aboutUs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aboutUs"])
      });
    }
  